{
  "title": "Leaving Patreon. Moving to Demos",
  "shortTitle": "Leaving Patreon. Moving to Demos",
  "subtitle": "I have been sharing React Native Demos on Patreon for the past 2 years, and I have decided to move to my own platform: Demos",
  "author": "Enzo Manuel Mangano",
  "date": "2024-11-21",
  "slug": "leaving-patreon",
  "tags": ["thoughts"],
  "featuredImage": "./images/header.webp",
  "series": "thoughts"
}
